import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  TextField,
} from '@material-ui/core';
import * as events from '../../../events';

import styles from './styles.module.css';
import LoginMessageSnackbar from './LoginMessageSnackbar';

const messages = defineMessages({
  FORGOT_PASSWORD: {
    id: 'FORGOT_PASSWORD',
    defaultMessage: 'Forgot Password',
  },
  FORGOT_PASSWORD_HELPTEXT: {
    id: 'FORGOT_PASSWORD_HELPTEXT',
    // eslint-disable-next-line max-len
    defaultMessage: 'Please provide your Login Name so we can send a password reset link to the email linked to your account.',
  },
  SEND: {
    id: 'SEND',
    defaultMessage: 'Send',
  },
  BACK_TO_LOGIN: {
    id: 'BACK_TO_LOGIN',
    defaultMessage: 'Back to login',
  },
  LOGIN_NAME: {
    id: 'LOGIN_NAME',
    defaultMessage: 'Login Name',
  },
  LOGIN_NAME_REQUIRED: {
    id: 'LOGIN_NAME_REQUIRED',
    defaultMessage: 'Login name required',
  },
});

function ForgotPassword({ intl }) {
  const dispatch = useDispatch();

  const [login, setLogin] = useState('');
  const [loginErr, setLoginErr] = useState('');
  const [reqAttempted, setReqAttempted] = useState(false);

  const onLoginChange = (e) => {
    setLogin(e.target.value);

    if (!e.target.value) {
      setLoginErr(intl.formatMessage({ ...messages.LOGIN_NAME_REQUIRED }));
    } else {
      setLoginErr('');
    }
  };

  const forgotPasswordSubmit = (e) => {
    e.preventDefault();

    if (!login) {
      setLoginErr(intl.formatMessage({ ...messages.LOGIN_NAME_REQUIRED }));
      setReqAttempted(true);
    } else {
      dispatch(events.forgotPassword(login));
    }
  };

  const resetForm = () => {
    setReqAttempted(false);
  };

  return (
    <div className={`${styles.loginCard} animate__animated animate__fadeIn`}>
      <Card className={styles.card} style={{ textAlign: 'left' }}>
        <CardHeader style={{ paddingLeft: 32 }} title={intl.formatMessage({ ...messages.FORGOT_PASSWORD })} />

        <CardContent className={styles.content} classes={{ root: styles.loginFormCard }}>
          <div style={{ color: '#333', paddingLeft: 16 }}>
            <FormattedMessage {...messages.FORGOT_PASSWORD_HELPTEXT} />
          </div>

          <form onSubmit={forgotPasswordSubmit} noValidate style={{ marginTop: 7 }}>
            <TextField
              required
              id="login"
              type="text"
              onFocus={resetForm}
              onBlur={onLoginChange}
              onChange={onLoginChange}
              className={styles.textField}
              label={intl.formatMessage({ ...messages.LOGIN_NAME })}
              error={reqAttempted && Boolean(loginErr)}
            />
            <Button
              fullWidth
              size="large"
              type="submit"
              color="primary"
              variant="contained"
              className={styles.loginBtn}
            >
              <FormattedMessage {...messages.SEND} />
            </Button>
          </form>
        </CardContent>
      </Card>

      <LoginMessageSnackbar />

    </div>
  );
}

export default injectIntl(ForgotPassword);
